export default __webpack_public_path__ + "static/N0268-1a7cd60f3b9d29f32fba218226c399c2.png";